'use client'

import dynamic from 'next/dynamic'

export const PaymentsCompleteScreenDialogClient = dynamic(
  () =>
    import('payments/payments-dialog/components/payments-complete-screen-dialog-modal').then(
      mod => mod.PaymentsCompleteScreenDialog,
    ),
  {
    ssr: false,
  },
)
